import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 18 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.45, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Hud = ({ children, className = "" }) => (
  <p className={`font-body text-sm font-bold uppercase tracking-[0.25em] text-gold ${className}`}>
    <span className="mr-3 inline-block h-2.5 w-8 bg-gold align-middle" aria-hidden="true" />
    {children}
  </p>
);
